const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:8000";

const getHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

export const getPMProjects = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/my-projects/`,
      {
        method: "GET",
        headers: getHeaders(),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.error || "Failed to fetch projects"
      );
    }

    return data;
  } catch (error) {
    console.error("Project Fetch Error:", error);
    throw error;
  }
};